export default `[hide] {
  display: none;
}

li,
:host {
  --ids-badge-disabled-background-color: var(--ids-list-view-item-color-background-disabled);
  --ids-badge-disabled-border-color: var(--ids-list-view-item-color-border-disabled);
  --ids-badge-disabled-text-color: var(--ids-list-view-item-badge-color-text-disabled);
  --ids-list-view-item-padding: var(--ids-space-sm);
  --ids-hyperlink-font-weight: var(--ids-font-weight-bold);
  --ids-list-view-data-label-spacing: 2px;
  display: block;
  background: var(--ids-color-transparent);
  border: var(--ids-list-view-item-border);
  border-top-color: var(--ids-list-view-item-color-border-top);
  contain: content;
  list-style-type: none;
  margin: 0;
  padding: var(--ids-list-view-item-padding);
  position: relative;
}
li .alert-border,
:host .alert-border {
  position: absolute;
  inset-inline-start: 0;
  inset-block: 0;
  width: 4px;
  border-radius: var(--ids-list-view-item-alert-banner-border-radius);
}
li .alert-border.alert-success,
:host .alert-border.alert-success {
  background: var(--ids-color-success-default);
}
li .alert-border.alert-error,
:host .alert-border.alert-error {
  background: var(--ids-color-error-default);
}
li .alert-border.alert-warning, li .alert-border.alert-alert,
:host .alert-border.alert-warning,
:host .alert-border.alert-alert {
  background: var(--ids-color-warning-default);
}
li .alert-border.alert-info,
:host .alert-border.alert-info {
  background: var(--ids-color-info-default);
}
li .list-item-area,
:host .list-item-area {
  display: flex;
  align-items: center;
  gap: var(--ids-space-md);
  line-height: var(--ids-list-builder-item-line-height);
}
li .list-item-area.ellipsis,
:host .list-item-area.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
li .list-item-area .list-item-content,
:host .list-item-area .list-item-content {
  display: flex;
  width: 100%;
  align-items: center;
  gap: var(--ids-space-xs);
}
li .list-item-area .list-item-content .slot-container,
:host .list-item-area .list-item-content .slot-container {
  display: block;
}
li .list-item-area .escalated-text,
:host .list-item-area .escalated-text {
  color: var(--ids-icon-status-color-red-color-text);
  margin-inline-start: 14px;
}
li .list-item-area .escalated-text::before,
:host .list-item-area .escalated-text::before {
  content: "";
  background-color: var(--ids-icon-status-color-red-color-text);
  border-radius: 50%;
  height: 8px;
  margin-inline-start: -14px;
  margin-block-start: 6px;
  position: absolute;
  width: 8px;
}
li .list-item-area .list-item-footer,
:host .list-item-area .list-item-footer {
  width: 100%;
}
li .list-item-area .list-item-footer .comments-time,
:host .list-item-area .list-item-footer .comments-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
li .list-item-area ::slotted([slot=icon]),
:host .list-item-area ::slotted([slot=icon]) {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--ids-icon-width-default);
  height: var(--ids-icon-height-default);
  border-radius: 25px;
  padding: var(--ids-space-2xs);
}
li .list-item-area ::slotted(img[slot=icon]),
:host .list-item-area ::slotted(img[slot=icon]) {
  width: var(--ids-list-view-image-width);
  height: var(--ids-list-view-image-height);
  border-radius: 50%;
  align-self: flex-start;
  object-fit: cover;
  padding: var(--ids-space-01);
}
li .list-item-area ::slotted(ids-alert[icon=info]),
:host .list-item-area ::slotted(ids-alert[icon=info]) {
  background: var(--ids-icon-status-color-blue-color-background);
}
li .list-item-area ::slotted(ids-alert[icon=success]),
:host .list-item-area ::slotted(ids-alert[icon=success]) {
  background: var(--ids-icon-status-color-green-color-background);
}
li .list-item-area ::slotted(ids-alert[icon=error]),
:host .list-item-area ::slotted(ids-alert[icon=error]) {
  background: var(--ids-icon-status-color-red-color-background);
}
li .list-item-area ::slotted(ids-alert[icon=warning]),
li .list-item-area ::slotted(ids-alert[icon=alert]),
:host .list-item-area ::slotted(ids-alert[icon=warning]),
:host .list-item-area ::slotted(ids-alert[icon=alert]) {
  background: var(--ids-icon-status-color-orange-color-background);
}
li .list-item-area ::slotted(ids-alert[slot=alert]),
:host .list-item-area ::slotted(ids-alert[slot=alert]) {
  display: flex;
  background: transparent;
}
li .list-item-area .list-item-checkbox,
:host .list-item-area .list-item-checkbox {
  padding-inline-end: var(--ids-space-20);
  flex-grow: 0;
  flex-shrink: 0;
  max-height: var(--ids-space-sm);
  max-width: var(--ids-space-sm);
  margin-block-start: -20px;
}
li .list-item-area .list-item-checkbox[disabled]::part(checkmark),
:host .list-item-area .list-item-checkbox[disabled]::part(checkmark) {
  background-color: var(--ids-color-transparent);
}
li .list-item-area ids-badge,
:host .list-item-area ids-badge {
  height: 24px;
}
li .list-item-area .alert-slot,
:host .list-item-area .alert-slot {
  min-width: 94px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
li .list-item-area .alert-slot:empty,
:host .list-item-area .alert-slot:empty {
  display: none;
}
li .list-item-area .list-item-buttonset,
:host .list-item-area .list-item-buttonset {
  display: flex;
  align-items: center;
}
li .list-item-area .list-item-buttonset ::slotted(ids-button:not(:first-child):not([no-padding])),
li .list-item-area .list-item-buttonset ::slotted(ids-menu-button:not(:first-child):not([no-padding])),
:host .list-item-area .list-item-buttonset ::slotted(ids-button:not(:first-child):not([no-padding])),
:host .list-item-area .list-item-buttonset ::slotted(ids-menu-button:not(:first-child):not([no-padding])) {
  margin-inline-start: 16px;
}
li .list-item-area.has-buttonset,
:host .list-item-area.has-buttonset {
  align-items: flex-start;
}
li .list-item-area.has-buttonset ::slotted(ids-alert[slot=icon][align=top]),
:host .list-item-area.has-buttonset ::slotted(ids-alert[slot=icon][align=top]) {
  align-self: flex-start;
  margin-block-start: var(--ids-space-2xs);
}
li .list-item-area.has-buttonset .list-item-buttonset,
:host .list-item-area.has-buttonset .list-item-buttonset {
  align-items: flex-start;
  margin-block-start: var(--ids-space-2xs);
}
li .list-item-area.has-buttonset-only,
:host .list-item-area.has-buttonset-only {
  align-items: flex-start;
}
li .list-item-area.has-buttonset-only .list-item-buttonset,
:host .list-item-area.has-buttonset-only .list-item-buttonset {
  align-items: flex-start;
  margin-block-start: var(--ids-space-2xs);
}

li:hover,
:host(:hover) {
  background-color: var(--ids-list-view-color-background-hover);
  background-image: linear-gradient(var(--ids-list-view-color-background-hover), var(--ids-list-view-color-background-hover));
  cursor: pointer;
}

@media (hover: none) {
  li:hover,
  :host(:hover) {
    background-color: var(--ids-color-transparent);
    background-image: none;
  }
}
li.activated,
li[activated],
li.selected,
li[selected],
:host(.activated),
:host([activated]),
:host(.selected),
:host([selected]) {
  display: block;
  cursor: pointer;
  background-color: var(--ids-list-view-color-background-selected);
}

li.selected:hover,
li[selected]:hover,
:host(.selected):hover,
:host([selected]):hover {
  background-color: var(--ids-list-view-color-background-selected);
}

:host([hide-selected-color]) {
  background-color: var(--ids-color-transparent);
}

li:focus,
li:focus-visible,
li:focus-within,
:host(:focus),
:host(:focus-visible),
:host(:focus-within) {
  display: block;
  border-color: var(--ids-list-view-item-color-border-focus);
  box-shadow: var(--ids-list-view-item-shadow-focus);
  outline: var(--ids-list-view-item-outline-focus);
}

li.disabled,
li[disabled],
.disabled,
[disabled],
:host(:hover[disabled]),
:host([disabled]:hover),
:host([disabled]),
:host(.disabled) {
  background-color: var(--ids-list-view-item-color-background-default);
  color: var(--ids-list-view-item-color-text-disabled);
  cursor: var(--ids-cursor-default);
  pointer-events: none;
  user-select: none;
}
li.disabled .alert-border,
li.disabled .list-item-alert,
li.disabled ids-badge,
li.disabled .escalated-text,
li.disabled .list-item-footer,
li[disabled] .alert-border,
li[disabled] .list-item-alert,
li[disabled] ids-badge,
li[disabled] .escalated-text,
li[disabled] .list-item-footer,
.disabled .alert-border,
.disabled .list-item-alert,
.disabled ids-badge,
.disabled .escalated-text,
.disabled .list-item-footer,
[disabled] .alert-border,
[disabled] .list-item-alert,
[disabled] ids-badge,
[disabled] .escalated-text,
[disabled] .list-item-footer,
:host(:hover[disabled]) .alert-border,
:host(:hover[disabled]) .list-item-alert,
:host(:hover[disabled]) ids-badge,
:host(:hover[disabled]) .escalated-text,
:host(:hover[disabled]) .list-item-footer,
:host([disabled]:hover) .alert-border,
:host([disabled]:hover) .list-item-alert,
:host([disabled]:hover) ids-badge,
:host([disabled]:hover) .escalated-text,
:host([disabled]:hover) .list-item-footer,
:host([disabled]) .alert-border,
:host([disabled]) .list-item-alert,
:host([disabled]) ids-badge,
:host([disabled]) .escalated-text,
:host([disabled]) .list-item-footer,
:host(.disabled) .alert-border,
:host(.disabled) .list-item-alert,
:host(.disabled) ids-badge,
:host(.disabled) .escalated-text,
:host(.disabled) .list-item-footer {
  opacity: var(--ids-list-view-item-opacity-disabled);
}
li.disabled .list-item-alert,
li[disabled] .list-item-alert,
.disabled .list-item-alert,
[disabled] .list-item-alert,
:host(:hover[disabled]) .list-item-alert,
:host([disabled]:hover) .list-item-alert,
:host([disabled]) .list-item-alert,
:host(.disabled) .list-item-alert {
  cursor: default;
}
li.disabled ::slotted([slot=icon]),
li[disabled] ::slotted([slot=icon]),
.disabled ::slotted([slot=icon]),
[disabled] ::slotted([slot=icon]),
:host(:hover[disabled]) ::slotted([slot=icon]),
:host([disabled]:hover) ::slotted([slot=icon]),
:host([disabled]) ::slotted([slot=icon]),
:host(.disabled) ::slotted([slot=icon]) {
  opacity: var(--ids-list-view-item-opacity-disabled);
}
li.disabled .list-item-buttonset,
li[disabled] .list-item-buttonset,
.disabled .list-item-buttonset,
[disabled] .list-item-buttonset,
:host(:hover[disabled]) .list-item-buttonset,
:host([disabled]:hover) .list-item-buttonset,
:host([disabled]) .list-item-buttonset,
:host(.disabled) .list-item-buttonset {
  opacity: var(--ids-list-view-item-opacity-disabled);
  pointer-events: none;
}
li.disabled ::slotted(ids-text),
li.disabled ::slotted(ids-icon),
li[disabled] ::slotted(ids-text),
li[disabled] ::slotted(ids-icon),
.disabled ::slotted(ids-text),
.disabled ::slotted(ids-icon),
[disabled] ::slotted(ids-text),
[disabled] ::slotted(ids-icon),
:host(:hover[disabled]) ::slotted(ids-text),
:host(:hover[disabled]) ::slotted(ids-icon),
:host([disabled]:hover) ::slotted(ids-text),
:host([disabled]:hover) ::slotted(ids-icon),
:host([disabled]) ::slotted(ids-text),
:host([disabled]) ::slotted(ids-icon),
:host(.disabled) ::slotted(ids-text),
:host(.disabled) ::slotted(ids-icon) {
  opacity: var(--ids-list-view-item-opacity-disabled);
}
li.disabled .list-item-content .slot-container,
li[disabled] .list-item-content .slot-container,
.disabled .list-item-content .slot-container,
[disabled] .list-item-content .slot-container,
:host(:hover[disabled]) .list-item-content .slot-container,
:host([disabled]:hover) .list-item-content .slot-container,
:host([disabled]) .list-item-content .slot-container,
:host(.disabled) .list-item-content .slot-container {
  opacity: var(--ids-list-view-item-opacity-disabled);
  pointer-events: none;
}
li.disabled:focus,
li[disabled]:focus,
.disabled:focus,
[disabled]:focus,
:host(:hover[disabled]):focus,
:host([disabled]:hover):focus,
:host([disabled]):focus,
:host(.disabled):focus {
  border-color: var(--ids-list-view-item-color-border-disabled-focus);
  border-top-color: var(--ids-list-view-item-top-color-border-disabled-focus);
  box-shadow: var(--ids-list-view-item-shadow-disabled-focus);
}

:host([escalated]) .list-item-area {
  display: block;
}

.sortable li,
[sortable] li,
.sortable,
[sortable],
.sortable :host,
[sortable] :host {
  cursor: inherit;
  display: block;
}

@media (max-width: 767px) {
  :host {
    padding: var(--ids-space-xs);
  }
  :host .list-item-area {
    gap: var(--ids-space-00);
  }
  :host .list-item-area .list-item-buttonset ::slotted(ids-button:not(:first-child):not([no-padding])) {
    margin-inline-start: var(--ids-space-00);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
